import React from 'react';
import { Carousel } from 'react-bootstrap';
import './FeaturedProfilesCarousel.scss';
import vaxess from '../../../assets/images/featured_testimonials/vaxess-featured.png';
import atai from '../../../assets/images/featured_testimonials/atai-featured.png';
import pioneering from '../../../assets/images/featured_testimonials/pioneering-medicines.png';
import biotech from '../../../assets/images/featured_testimonials/biotech-podcast-featured.png';
import talent from '../../../assets/images/featured_testimonials/talent-acquisition-featured.png';
import FeaturedProfilesCarouselCard from './FeaturedProfileCarouselCard';
function FeaturedProfilesCarousel() {
  return /*#__PURE__*/React.createElement("div", {
    className: "carousel-container"
  }, /*#__PURE__*/React.createElement(Carousel, null, /*#__PURE__*/React.createElement(Carousel.Item, {
    key: 1
  }, /*#__PURE__*/React.createElement(FeaturedProfilesCarouselCard, {
    image: vaxess,
    title: "\"I was super impressed with my first experience using Clora\"",
    text: 'They were able to find me the talent I needed quickly and efficiently.' + ' She is proactive and anticipates things we need to do before I even ask her,' + ' exceeding our expectations. We will definitely come back to Clora for future needs.',
    source: "Vaxess Technologies, Hiring Manager"
  })), /*#__PURE__*/React.createElement(Carousel.Item, {
    key: 2
  }, /*#__PURE__*/React.createElement(FeaturedProfilesCarouselCard, {
    image: atai,
    title: "\"Very pleased with both my consultant and with Clora\u201D",
    text: 'My consultant has been a critical player in all aspects for our Phase 2a study.' + ' Clora has made sure the engagement goes smoothly and I have felt supported by them ' + ' from start to finish. I will definitely look to them for future needs!',
    source: "Atai Life Sciences, Hiring Manager"
  })), /*#__PURE__*/React.createElement(Carousel.Item, {
    key: 3
  }, /*#__PURE__*/React.createElement(FeaturedProfilesCarouselCard, {
    image: pioneering,
    title: "\u201CClora is a great partner.\u201D",
    text: 'They have identified a number of experts for us. They know us and our business ' + 'well and work hard to understand the talent we need, access their large ' + 'network, and quickly find the right match. We have been impressed. ',
    source: "Pioneering Medicine, Hiring Manager"
  })), /*#__PURE__*/React.createElement(Carousel.Item, {
    key: 4
  }, /*#__PURE__*/React.createElement(FeaturedProfilesCarouselCard, {
    image: talent,
    title: "It\u2019s Time to Rethink Biotech Talent Acquisition",
    text: 'The industry is facing a talent crisis, but it’s not because of a shortage of' + ' talent. In our newest report, we explain how companies can adapt to industry ' + 'shifts and come out on top.',
    source: "Request a Copy",
    link: "https://go.clora.com/rethinking-biotech-talent-acquisition-download-now/"
  })), /*#__PURE__*/React.createElement(Carousel.Item, {
    key: 5
  }, /*#__PURE__*/React.createElement(FeaturedProfilesCarouselCard, {
    image: biotech,
    title: "Biotech2050 Podcast: Chronicling the Disruptive Forces in Biopharma",
    text: "Catch up on the episodes everyone is talking about.",
    source: "Listen Now",
    link: "https://www.biotech2050.com/episode"
  }))));
}
export default FeaturedProfilesCarousel;